import React from "react";
import Dissatisfied from "@material-ui/icons/SentimentVeryDissatisfied";
import { useStyles } from "components/layout/CommonStyles";
import { useTranslation } from "react-i18next";

export default function NoResultOnSearch({ notFound }) {
  const classes = useStyles();
  const [t] = useTranslation();
  return (
    <div className={classes.noParticipantsMessage}>
      <div>
        <Dissatisfied className={classes.notFoundIconStyle} />
      </div>
      <h2>{t("GENERAL.noResultsFound")}</h2>
      <h5>{`Sua busca por "${notFound}" não retornou resultados.`}</h5>
    </div>
  );
}
